export default "__VITE_ASSET__C$dZRBAZ__"